<div class="row top-content-row">
  <div class="col-md-12">
    <h1 class="heading">Communications</h1>
  </div>


  <div *ngIf="selectedCategorySelector$ | async as selectedCategory">
  <!--      SIDE BUTTON PANEL-->
  <div class="sideBtnPanel">
    <div *ngIf="selectedCategory != null && selectedCategory.communicationsCategoryId !== 'latepayment'">
    <button
        class="btn btn-primary"
        name="browse-btn"
        [ngClass]="{
            'btn-right-open': !browserOpen}"
        (click)="openJobBrowser()"
        [disabled]="browserOpen"
    >
      <i class="glyphicon glyphicon-folder-open" style="margin-right: 16px; margin-left: 8px;"></i>
      <span>&nbsp;Browse Saved</span>
    </button>
    <button
        class="btn btn-primary"
        name="discard-btn"
        [disabled]="browserOpen"
        (click)="clone()"
    >
      <i class="glyphicon glyphicon-duplicate" style="margin-right: 16px; margin-left: 8px;"></i>&nbsp;Create copy
    </button>
    <button
        class="btn btn-primary"
        name="discard-btn"
        [ngClass]="{
            'btn-right-open':
              false}"
        [disabled]="browserOpen"
        (click)="saveJob()"
    >
      <i class="glyphicon glyphicon-ok" style="margin-right: 16px; margin-left: 8px;"></i>&nbsp;Save changes
    </button>

    <button
        class="btn btn-primary"
        name="discard-btn"
        [ngClass]="{
            'btn-right-open':
              false}"
        [disabled]="browserOpen"
        (click)="viewReport()"
    >
      <i class="glyphicon glyphicon-file" style="margin-right: 16px; margin-left: 8px;"></i>&nbsp;View Report
    </button>
    </div>
  </div>
  <!--      end SIDE BUTTON PANEL-->



  <div class="col-md-12 communicationsTypes text-center">
    <div class="communicationCategories" style="overflow: hidden; padding-top: 12px">
      <ul style="margin-left: -32px; white-space: nowrap" *ngIf="categoriesSelector$ | async as categories">
        <li *ngFor="let category of categories"
            style="top: 0; display: list-item; float: left; cursor: pointer;">

          <div style="position: relative" (click)="selectCategory(category)">
            <div class="category-icon"
                 style="width: 100%; height: 100%;"
                 [ngClass]="{'category-icon-selected': selectedCategory === category}"
                 [ngStyle]="{'opacity': category.categoryEnabled ? 1.0 : 0.5}">
              <img src="img/communications/category/{{category.communicationsCategoryId}}.png"
                   alt="Communication Category"
                   style="width: 100px"/>
              <div *ngIf="category.automatedJobs>0"
                   style="position: absolute; left: 0; top: 0; width: 26px; height: 26px;">
                <img src="img/communications/category/auto_banner3.png" style="width: 26px" alt=""/>
              </div>
            </div>
          </div>
          <p [ngStyle]="{'font-weight': selectedCategory === category ? 600 : 400}">{{
              '_communicationsCategory_' + category.communicationsCategoryId + '_' | translate}}</p>
        </li>
      </ul>
    </div>
  </div>

    <!-- ************************************* Start step 2 design message **********************************-->
    <!-- ************************************* stop step 2 design message **********************************-->

  <div>
  </div>
  </div>
</div>